import { render } from "./photo_admin_dashboard.vue?vue&type=template&id=72dbf298&scoped=true"
import script from "./photo_admin_dashboard.vue?vue&type=script&lang=js"
export * from "./photo_admin_dashboard.vue?vue&type=script&lang=js"

import "./photo_admin_dashboard.vue?vue&type=style&index=0&id=72dbf298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dbf298"]])

export default __exports__